import * as yup from "yup";


export const prequalSchema = yup.object({
    otherLoan: yup.boolean().required("Other loan is required").nullable(),
    dob: yup.string().required("Date of birth is required").nullable(),
    employmentType: yup
      .string()
      .required("Employment type is required")
      .nullable(),
    email: yup.string().email().required("Email is required").nullable(),

    netSalary: yup
      .number()
      .required("Salary/income is required")
      .nullable()
      .typeError("Salary/income is required"),
    propertyPrice: yup
      .number()
      .required("Property price is required")
      .nullable()
      .typeError("Property price is required"),

    interestRate: yup
      .number()
      .required("Interest rate is required")
      .nullable()
      .typeError("Interest rate is required"),
    tenor: yup
      .number()
      .required("Tenor is required")
      .nullable()
      .typeError("Tenor is required"),
  });